import { GraphAnnotationModel, GraphAnnotationType } from '../core/api/models';
import { Utils } from '../core/utils';
import { getTextPositionLabel } from '../shared/utils/utils';

export enum AnnotationLabelBackgroundOption {
  Solid = 'Solid',
  Transparent = 'Transparent',
}

export function annotationSupportsLabelPosition(annotation: GraphAnnotationModel): boolean {
  const type = annotation.GraphAnnotationType;
  return (
    type === GraphAnnotationType.XAxis ||
    type === GraphAnnotationType.XAxisRange ||
    type === GraphAnnotationType.YAxis ||
    type === GraphAnnotationType.YAxisRange
  );
}

export function resolveAnnotationLabelPositionValue(
  annotation: GraphAnnotationModel
): 'start' | 'middle' | 'end' {
  const position = annotation.LabelPosition;
  if (position === 'start' || position === 'end') {
    return position;
  }
  return 'middle';
}

export function graphAnnotationDisplayLabel(annotation: GraphAnnotationModel): string {
  switch (annotation.GraphAnnotationType) {
    case GraphAnnotationType.Point:
      return `${annotation.Label} - ${new Date(annotation.StartDate!).toLocaleDateString()} - ${annotation.YValueStart} - ${Utils.graphAnnotationTypeLabel(annotation.GraphAnnotationType!)}`;
    case GraphAnnotationType.Text:
      return `${annotation.Label} - ${getTextPositionLabel(annotation.YValueStart, annotation.YValueEnd)} - ${Utils.graphAnnotationTypeLabel(annotation.GraphAnnotationType!)}`;
    case GraphAnnotationType.XAxis:
      return `${annotation.Label} - ${Utils.graphAnnotationTypeLabel(annotation.GraphAnnotationType!)} - ${new Date(annotation.StartDate!).toLocaleDateString()}`;
    case GraphAnnotationType.XAxisRange:
      return `${annotation.Label} - ${Utils.graphAnnotationTypeLabel(annotation.GraphAnnotationType!)} - ${new Date(annotation.StartDate!).toLocaleDateString()} - ${new Date(annotation.EndDate!).toLocaleDateString()}`;
    case GraphAnnotationType.YAxis:
      return `${annotation.Label} - ${Utils.graphAnnotationTypeLabel(annotation.GraphAnnotationType!)} - ${annotation.YValueStart}`;
    case GraphAnnotationType.YAxisRange:
      return `${annotation.Label} - ${Utils.graphAnnotationTypeLabel(annotation.GraphAnnotationType!)} - ${annotation.YValueStart} - ${annotation.YValueEnd}`;
    default:
      return `${annotation.Label} - ${Utils.graphAnnotationTypeLabel(annotation.GraphAnnotationType!)}`;
  }
}
